export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.847 2.012a1 1 0 011.072.595l2.87 6.696c.227.53.15 1.233-.382 1.685-.948.806-2.206 1.173-3.407 1.173s-2.46-.367-3.407-1.173c-.532-.452-.61-1.156-.382-1.686l2.076-4.844L13 5.78V19h3v2H8v-2h3V6.28L5.357 7.69l2.43 5.61c.23.53.153 1.225-.362 1.679-1.873 1.65-4.977 1.65-6.85 0-.515-.454-.591-1.15-.362-1.678l2.802-6.474a1 1 0 01.743-.797l16-4 .089-.018zm-17.634 11.7c1.033.668 2.54.668 3.573 0L4 9.589l-1.787 4.125zm16.005-4.016c.49.295 1.116.465 1.782.465.665 0 1.292-.17 1.781-.465L20 5.538l-1.782 4.158z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};